<template>
  <div class="main">
    <v-sheet>
      <TipTapReader v-if="options.content" class="tiptap_style" :options="options" :key="componentKey" />
    </v-sheet>
    <div class="bottomFixedButton" :class="hasPromotionCode() ? 'd-flex' : 'd-none'">
      <v-btn large width="50%" color="primary" style="font-size: 25px" class="rounded-10 darken-1" depressed @click="goReserve">
        {{ $t("button.do-reserve") }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import TipTapReader from "@/components/tiptap/Reader"
import { mapState } from "vuex"
export default {
  components: {
    TipTapReader,
  },
  data: () => ({
    //TipTap
    options: {
      content: "",
      readonly: true,
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    eventData: {},
  }),

  mounted() {
    console.log("event: ", this.$route.params.eventCode)
    this.$http
      .get("/api/event/select/code", {
        params: {
          code: this.$route.params.eventCode,
        },
      })
      .then((res) => {
        this.eventData = res.data[0]
        this.options.content = this.getContent()
        this.componentKey++
      })
  },
  watch: {
    lang() {
      this.options.content = this.getContent()
      this.componentKey++
    },
  },

  computed: {
    ...mapState(["lang"]),
  },

  methods: {
    getContent() {
      if (!this.eventData) {
        return ""
      }
      switch (this.lang) {
        case "jp":
          return this.eventData.content_jp || this.eventData.content
        case "en":
          return this.eventData.content_en || this.eventData.content
        default:
          return this.eventData.content || ""
      }
    },
    hasPromotionCode() {
      return this.eventData.promotionCode ? true : false
    },
    goReserve: _.debounce(function () {
      console.log("goReserve")
      // 예약하기 화면으로 이동
      this.$router.push({ path: "/booking/reserve", query: { event: this.eventData.promotionCode } })
    }, 500),
  },
}
</script>
<style scoped>
.main {
  position: relative;
  overflow-y: auto;
  padding-bottom: 100px !important;
}
.bottomFixedButton {
  max-width: 580px;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 72px;
  padding-bottom: 10px;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}
</style>
